import {domains} from '../../constants/Utils';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';

export const COURTESY_CARS_PRICING_SELECT_GROUP = 'COURTESY_CARS_PRICING_SELECT_GROUP';
export const COURTESY_CARS_PRICING_FETCH_PENDING = 'COURTESY_CARS_PRICING_FETCH_PENDING';
export const COURTESY_CARS_FETCH_SUCCESS = 'COURTESY_CARS_FETCH_SUCCESS';
export const COURTESY_CARS_FETCH_ERROR = 'COURTESY_CARS_FETCH_ERROR';
export const COURTESY_CARS_FETCH_PENDING = 'COURTESY_CARS_FETCH_PENDING';
export const COURTESY_CARS_SAVE_FETCH_SUCCESS = 'COURTESY_CARS_SAVE_FETCH_SUCCESS';
export const COURTESY_CARS_PRICING_SAVE_PENDING = 'COURTESY_CARS_SAVE_PENDING';

export const storeSelectedCountryGroup = countryGroup => dispatch => {
    dispatch({type: COURTESY_CARS_PRICING_SELECT_GROUP, payload: countryGroup});
}


export const fetchCourtesyCarsPricing = (domain, group) => dispatch => {
    switch (domain) {
        case domains.SPARE_PARTS: {
            return dispatch({
                type: COURTESY_CARS_PRICING_FETCH_PENDING,
                sparePartsWebsocket: true,
                command: sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_COURTESY_CARS_PRICING_GET,
                payload: {group}
            });
        }

    }
};

export const saveCourtesyCarsPricing = (domain, courtesyCarsPricing) => dispatch => {
    switch (domain) {
        case domains.SPARE_PARTS: {
            return dispatch({
                type: COURTESY_CARS_PRICING_SAVE_PENDING,
                sparePartsWebsocket: true,
                command: sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_COURTESY_CARS_PRICING_SET,
                payload: {courtesyCarsPricing}
            });
        }
    }
}
